import { render, staticRenderFns } from "./PreRegisStepper.vue?vue&type=template&id=a5e3dd86"
import script from "./PreRegisStepper.vue?vue&type=script&lang=js"
export * from "./PreRegisStepper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports